export default "__VITE_ASSET__DXXsMpft__"